import { render, staticRenderFns } from "./RsaPazienteMovimentiContabiliListPage.vue?vue&type=template&id=be6f3106"
import script from "./RsaPazienteMovimentiContabiliListPage.vue?vue&type=script&lang=js"
export * from "./RsaPazienteMovimentiContabiliListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports